// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bfftypes/v1/procurement_plan_auto_resubmit_category.proto (package bfftypes.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file bfftypes/v1/procurement_plan_auto_resubmit_category.proto.
 */
export const file_bfftypes_v1_procurement_plan_auto_resubmit_category: GenFile = /*@__PURE__*/
  fileDesc("CjliZmZ0eXBlcy92MS9wcm9jdXJlbWVudF9wbGFuX2F1dG9fcmVzdWJtaXRfY2F0ZWdvcnkucHJvdG8SC2JmZnR5cGVzLnYxKtMBCiNQcm9jdXJlbWVudFBsYW5BdXRvUmVzdWJtaXRDYXRlZ29yeRI3CjNQUk9DVVJFTUVOVF9QTEFOX0FVVE9fUkVTVUJNSVRfQ0FURUdPUllfVU5TUEVDSUZJRUQQABI1CjFQUk9DVVJFTUVOVF9QTEFOX0FVVE9fUkVTVUJNSVRfQ0FURUdPUllfREVNQU5EX0JHEAESPAo4UFJPQ1VSRU1FTlRfUExBTl9BVVRPX1JFU1VCTUlUX0NBVEVHT1JZX1NFTEZfV0hFRUxJTkdfQkcQAkJCWkBnaXRodWIuY29tL2VuZWNoYWluL2ViYWxhbmNlL2dvL2dlbi9wcm90by9iZmZ0eXBlcy92MTtiZmZ0eXBlc3YxYgZwcm90bzM");

/**
 * ProcurementPlanAutoResubmitCategory is the 区分 that, together with the
 * area, keys a 需要調達計画 automatic-resubmission setting
 * (plan-auto-resubmit.md AC-PAR-001; 区分 of bg.md AC-OMB-026).
 *
 * Wire values mirror backend types.v1.ProcurementPlanAutoResubmitCategory.
 *
 * @generated from enum bfftypes.v1.ProcurementPlanAutoResubmitCategory
 */
export enum ProcurementPlanAutoResubmitCategory {
  /**
   * @generated from enum value: PROCUREMENT_PLAN_AUTO_RESUBMIT_CATEGORY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 需要BG
   *
   * @generated from enum value: PROCUREMENT_PLAN_AUTO_RESUBMIT_CATEGORY_DEMAND_BG = 1;
   */
  DEMAND_BG = 1,

  /**
   * 自己託送BG
   *
   * @generated from enum value: PROCUREMENT_PLAN_AUTO_RESUBMIT_CATEGORY_SELF_WHEELING_BG = 2;
   */
  SELF_WHEELING_BG = 2,
}

/**
 * Describes the enum bfftypes.v1.ProcurementPlanAutoResubmitCategory.
 */
export const ProcurementPlanAutoResubmitCategorySchema: GenEnum<ProcurementPlanAutoResubmitCategory> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_procurement_plan_auto_resubmit_category, 0);

